<template>
  <div class="client opportunity key-offerings-editor">
    <v-btn icon @click="editing = !editing"> <v-icon>mdi-pencil</v-icon> </v-btn>
    <v-dialog scrollable v-model="editing" max-width="900px" width="66vw" height="50">
      <v-card>
        <v-card-title class="title">Edit Key Offerings</v-card-title>

        <v-divider />

        <v-card-text>
          <v-form v-model="valid" @submit.prevent="submit" ref="form">
            <v-combobox
              multiple
              label="Key offerings"
              v-model="opportunityOfferings.offerings"
              :items="[]"
              append-icon=""
              :color="themes.client.light.input"
            >
              <v-chip
                slot="selection"
                slot-scope="data"
                @input="data.parent.selectItem(data.item)"
                :class="themes.client.light.chip"
                :selected="data.selected"
                :key="`key-offerings-${data.item}`"
              >
                <v-icon left>mdi-checkbox-marked-circle</v-icon>
                {{ data.item }}
                <v-icon right small @click="data.parent.selectItem(data.item)">mdi-close</v-icon>
              </v-chip>
            </v-combobox>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="editing = false" :color="themes.client.light.cancel"> Cancel </v-btn>
          <v-btn :color="themes.client.light.primaryActionButton" :disabled="!valid" @click="submit">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// Vue Component
export default {
  props: {
    opportunity: Object,
    edit: Boolean,
  },
  data() {
    return {
      // Model
      opportunityOfferings: {
        offerings: this.opportunity.offerings || [],
      },
      editing: false,
      loading: false,
      valid: false,
    }
  },
  methods: {
    submit() {
      this.loading = true
      this.$store
        .dispatch(
          'client/opportunities/update',
          Object.assign({}, this.opportunity, this.opportunityOfferings)
        )
        .then(
          response => {
            this.$store.dispatch('snackbarSuccess', 'The offerings were updated successfully')
            this.editing = false
          },
          errors => {
            if (errors) {
              this.errors = errors
              this.$store.dispatch('snackbarError', 'There was a problem updating the offerings')
            } else {
              this.$store.dispatch('snackbarSuccess', 'The offerings were updated successfully')
              this.editing = false
            }
          }
        )
        .finally(() => (this.loading = false))
    },
  },
}
</script>
